export const ADD_CHILD = `parents/add_child`;
export const SET_LOADING = `parents/set_loading`;
export const SET_PARENTS = `parents/set_parents`;
export const SET_CHILDREN = `parents/set_children`;
export const REMOVE_CHILD = `parents/remove_child`;



// WEBPACK FOOTER //
// ./src/store/base/parents/types.js